import React from 'react';
import ComingSoon from 'components/ComingSoon';

export const Compliance = () => (
  <ComingSoon
    text="Stay up to date with the latest sustainability regulations effortlessly. This section provides legislative updates, compliance guidance, and future-proofing strategies, allowing you to focus on your core business while ensuring compliance and preparedness for upcoming regulations.
  Stay informed with the latest legislative changes in different countries and keep up with the newest developments in compliance."
  />
);
